import styles from './person.module.scss';
import { CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

/* eslint-disable-next-line */
export interface PersonProps {
  loan?: ILoan
}

export function Person(props: PersonProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={8} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.user?.person?.firstName || ''}
            fullWidth
            label={t("standard.firstName")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.user.person.lastname || ''}
            fullWidth
            label={t("standard.lastName")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.user.person.personId || ''}
            fullWidth
            label={t("standard.personID")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.retired")}
            checked={props.loan?.user?.person?.isRetired}
            disabled={true}
          />
          <CheckboxLabel
            label={t("standard.blocked")}
            checked={props.loan?.user?.isBlocked}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Person;